import React, {Component} from "react";
import {connect} from 'react-redux';
import {updateZStackLevel} from "../../../redux_actions/maps.state.action";
import "../../../asset/style/neoviewer/zoom_controls.css"
import {Add, Remove} from "@mui/icons-material";
import {BottomNavigation, BottomNavigationAction, Box, IconButton, Stack} from "@mui/material";
import Typography from "@mui/material/Typography";
import {notifyError} from "../utils/display.notification";
import {Loading} from "../components/components";
import {getViewLevelsInfo, isZoomForTiled} from "../utils/map_utils";
import {isNull} from "../../../utils/utils";

class ZStackControl extends Component {
	constructor(props) {
		super(props);

		this.state = {
			openPanel: false,
		}

		this.onStitchedLayer = true
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		if (this.onStitchedLayer && this.state.openPanel) {
			this.setState({openPanel: !this.state.openPanel})
		}
	}

	incrementZoomLevel = () => {
		if (!this.onStitchedLayer) {
			this.props.dispatch(updateZStackLevel(this.props.activeMapId, this.props.zStackLevel + 1));
		} else {
			notifyError("zstackerror", "Z aaaStack only allowed on higher zoom levels.", false, 2500);
		}
	}

	decrementZoomLevel = () => {
		if (!this.onStitchedLayer) {
			this.props.dispatch(updateZStackLevel(this.props.activeMapId, this.props.zStackLevel - 1));
		} else {
			notifyError("zstackerror", "Z Stack only allowed on higher zoom levels.", false, 2500);
		}
	}

	openPanelHelper = () => {
		if (this.onStitchedLayer){
			notifyError("zstackerror", "Z Stack only allowed on higher zoom levels.", false, 2500);
		}else {
			this.setState({openPanel : !this.state.openPanel})
		}
	}

	render() {
		if (window.location.href.includes("/blood/")) return null;

        if (isNull(this.props.slide))
			return <Loading/>;

		if (this.props.slide.scan_speed !== "ZSTACK")
			return null;

		let maxZLevel = this.props.slide.meta?.takeBidirectionalZStack ?
			(this.props.slide.meta?.numZLevels - 1) / 2 : (this.props.slide.meta?.numZLevels - 1);
		let minZLevel = this.props.slide.meta?.takeBidirectionalZStack ?
			(-1 * ((this.props.slide.meta?.numZLevels - 1) / 2)) : 0;

		let layersOverlayComponent;
		if (this.state.openPanel) {
			layersOverlayComponent = <Box sx={{
				height: '20vh', width: '4.3vw', border: '0px', bgcolor: "rgba(51, 4, 112,0.8)",
				display: "flex", overflowY: 'scroll',
			}}>
				<Typography sx={{width: '100%'}}>
					<Stack direction="column" justifyContent={"space-around"} marginTop={1} marginBottom={1}
						   sx={{height: '18vh'}}>
						<IconButton color={"secondary"}>
							<Typography sx={{fontSize: '0.8vw', height: '3vh',}}>ZStack</Typography>
						</IconButton>
						<IconButton
							color={"secondary"}
							onClick={this.incrementZoomLevel}
							disabled={this.props.zStackLevel >= maxZLevel || !this.props.slide.meta?.takeZStack}
							sx={{height: '6vh'}}
						>
							<Add fontSize="large"/>
						</IconButton>
						<IconButton
							color={"secondary"}
							onClick={this.decrementZoomLevel}
							disabled={this.props.zStackLevel <= minZLevel || !this.props.slide.meta?.takeZStack}
							sx={{height: '6vh'}}
						><Remove fontSize="large"/>
						</IconButton>
					</Stack>
				</Typography>
			</Box>
		}

		this.onStitchedLayer = !isZoomForTiled(this.props.slidemap.getView().getZoom(), getViewLevelsInfo(this.props.slide))
		const z_level = (this.onStitchedLayer) ? "--" : (this.props.zStackLevel * this.props.slide.meta?.levelJump).toFixed(1) + "µ"

		return(
		<Stack direction={"column-reverse"} alignItems={"flex-end"}>
			<BottomNavigation sx={{borderRadius:0, bgcolor:"rgba(51, 4, 112,0.8)", width: "4.3vw"}} value={this.state.app}
							  onChange={this.openPanelHelper}>
				<BottomNavigationAction icon={<Typography variant={'h5'} align={"center"} gutterBottom={true}
				                                          color={this.state.openPanel ? "secondary" : "white"}>
					{z_level}
				</Typography>} />
			</BottomNavigation>
			{layersOverlayComponent}
		</Stack>
		)
	}

	}
const mapStateToProps = (state) => {
	let activeMapId = state.gammaStateReducer.activeMapId;
    let {slide, slidemap, zStackLevel, z} = state.mapsStateReducer[activeMapId] ?? {};
	return {activeMapId, slide, slidemap, zStackLevel, z};
}

export default connect(mapStateToProps)(ZStackControl);
